define('core/extensions/helpers/with',[],function () {
    'use strict';

    /*
     * @with helper allows to change context of some part of template.
     * - in addition it may specify name of new context, i.e. wrap context
     *   into new object with some named property:
     *
     *      {{#with name=context}}
     *
     * - also if constant string '_window_' is passed, then context
     *   became global window object
     */
    return function () {
        var len = arguments.length;
        var options = arguments[len - 1];
        var context = arguments[0];

        if (len === 3) {
            context = {};
            context[arguments[0]] = arguments[1];
        } else if (context === '_window_') {
            context = window;
        }

        return options.fn(context);
    };
});

